/**
 * @generated SignedSource<<88ef102106b08bff4d1aaa416e57b6ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardTransitionZonesOld_query$data = {
  readonly jira_categoryField: {
    readonly displayName: string;
    readonly fieldId: string;
  } | null | undefined;
  readonly " $fragmentType": "BoardTransitionZonesOld_query";
};
export type BoardTransitionZonesOld_query$key = {
  readonly " $data"?: BoardTransitionZonesOld_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardTransitionZonesOld_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "BoardTransitionZonesOld_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraJqlField",
      "kind": "LinkedField",
      "name": "jira_categoryField",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "fieldId"
          },
          "action": "THROW",
          "path": "jira_categoryField.fieldId"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "displayName"
          },
          "action": "THROW",
          "path": "jira_categoryField.displayName"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "36f6ff80d7bee537193e582812a17099";

export default node;
